"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const estimation_1 = require("./estimation");
const matricesGeneration_1 = require("./matricesGeneration");
require("@tensorflow/tfjs-backend-cpu");
const utils_1 = require("./utils");
const ai_toolkit_1 = require("@evidenceb/ai-toolkit");
const irt_1 = require("./irt");
var tf = require("@tensorflow/tfjs-core");
tf.setBackend("cpu");
class ATM extends ai_toolkit_1.AIEngine {
    /**
     * Class that handles the adaptive test
     * @param params : config object (same as in the BM)
     * @param history : histroy of the BM if we want to exploit it (in case the test is launched in the middle or
     * at the end of a module)
     * @param discriminations : discriminations of all items in the test bank
     * @param difficulties : difficulties of all items in the test bank
     */
    constructor(config, bo = 1, nbMinQuestions = 0, nbMaxQuestions = 20, difficulties = undefined, history = undefined, discriminations = undefined, kFirst = 4) {
        super(config);
        this.difficulties = {}; //Matrice difficultés des activités
        this.actSequence = {}; //Sequence d'activité
        this.sequence = [];
        this.kFirst = 4; //nombre de premières questions à poser à l'élève
        this.IdKFirst = []; //5 premiers exercices
        this.rep_per_obj = {};
        this.finish = false; // critère d'arrêt si toutes les activités ont étaient évalué
        this.nb_quest = 0;
        this.discriminations_anc = {}; // matrice de dicrimination prenant en compte les prérequis
        this.discriminations_no_anc = {}; // matrice de discrimination sans prérequis mais avec plus d'importance pour les postrequis
        this.thetaEstimation = {};
        this.InformationMatrix = {};
        this.count_act = {}; // dict to count the number of time each activities has been seen {idAct : nbSeen}
        this.BO_act = {}; // the score in the BO for each activity {idAct : boScore}
        this.lvl_per_obj = {}; // output of the test, for each objective it gives an array stating if each activity in the obj is mastered or not
        this.parametricGraph = config.parametricGraph;
        this.ontology = new ai_toolkit_1.Ontology(this.params);
        // remplissage des objectifs, activités et exercices
        for (let obj of this.ontology.objectives) {
            this.rep_per_obj[obj] = 0;
            this.lvl_per_obj[obj] = new Array(this.ontology.activitiesOfObj[obj].length);
            this.lvl_per_obj[obj].fill(0);
            for (let act of this.ontology.activitiesOfObj[obj]) {
                this.count_act[act] = 0;
                this.BO_act[act] = 0;
            }
        }
        this.main_act = this.params["graph"]["main_act"];
        this.QMatrix = (0, matricesGeneration_1.generateQmatrixPrerequisite)(this.params);
        this.estimator = new estimation_1.NumericalSearchEstimator();
        this.history = history;
        this.actSequence["seq"] = [];
        this.actSequence["res"] = []; //résultat de l'élève
        this.actSequence["ex"] = []; //exercice demandé à l'élève
        this.actSequence["act"] = []; //activité
        this.actSequence["timestamp"] = [];
        this.actSequence["duration"] = [];
        this.actSequence["weight"] = [];
        this.sequence = [];
        this.nbMaxQuestions = nbMaxQuestions;
        this.nbMinQuestions = nbMinQuestions;
        this._minError = 0.1;
        this.kFirst = kFirst;
    }
    /**
     *
     * @returns la prochaine question à poser
     * au début retourne les questions non adaptatives puis enchaîne avec des .select()
     */
    sample() {
        if (this.actSequence["act"].length < this.kFirst) {
            let candidateAct = [];
            for (let i = 0; i < this.actSequence["weight"].length; i++) {
                if (this.actSequence["weight"][i] == 1) {
                    candidateAct.push(this.actSequence["act"][i]);
                }
            }
            for (let ID of this.IdKFirst) {
                //sélection des n (4) premières questions
                if (!candidateAct.includes(ID)) {
                    return ID;
                }
            }
        }
        return this.select();
    }
    select() {
        throw new Error("Method not implemented.");
    }
    sampleFromAnywhere() {
        let obj = this.ontology.objectives[Math.floor(Math.random() * this.ontology.objectives.length)];
        let act = this.ontology.activitiesOfObj[obj][Math.floor(Math.random() * this.ontology.activitiesOfObj[obj].length)];
        return act;
    }
    estimate() {
        throw new Error("Method not implemented.");
    }
    updateInfoMatrix() {
        throw new Error("Method not implemented.");
    }
    /**
     * updates the sequence of exercises done by a student with the last interaction
     * @param lastInteraction : information about the last exercise done by the student
     * @param weight : weight given to interactions coming from the BM history (if there are some)
     * @param nbLastSeen :maximum number of interactions in each activity taken from the BM
     */
    base_update(lastInteraction, weight = 0.2, nbLastSeen = 4) {
        let act = {};
        // change the try to an if but need to change get_act_id first or loop over exercise_ontolgy.keys
        try {
            if (!Object.keys(lastInteraction).includes("isAdaptiveTest")) {
                this.actSequence["seq"].push(act);
                this.actSequence["ex"].push(lastInteraction["exerciseId"]);
                this.actSequence["act"].push(lastInteraction["activityId"]);
                this.actSequence["res"].push(lastInteraction["score"] < 0.7 ? 0 : 1);
                this.sequence.push({
                    exerciseId: lastInteraction["exerciseId"],
                    activityId: lastInteraction["activityId"],
                    objectiveId: lastInteraction["objectiveId"],
                    score: lastInteraction["score"],
                });
                if (Object.keys(lastInteraction).includes("timestamp")) {
                    this.actSequence["timestamp"].push(lastInteraction["timestamp"]);
                }
                else {
                    this.actSequence["timestamp"].push(null);
                }
                if (Object.keys(lastInteraction).includes("duration")) {
                    this.actSequence["duration"].push(lastInteraction["duration"]);
                }
                else {
                    this.actSequence["duration"].push(0);
                }
                this.actSequence["weight"].push(1);
            }
            else if (lastInteraction["isAdaptiveTest"]) {
                this.actSequence["seq"].push(act);
                this.actSequence["ex"].push(lastInteraction["exerciseId"]);
                this.actSequence["act"].push(lastInteraction["activityId"]);
                this.actSequence["res"].push(lastInteraction["score"] < 0.7 ? 0 : 1);
                this.sequence.push({
                    exerciseId: lastInteraction["exerciseId"],
                    activityId: lastInteraction["activityId"],
                    objectiveId: lastInteraction["objectiveId"],
                    score: lastInteraction["score"],
                });
                if (Object.keys(lastInteraction).includes("timestamp")) {
                    this.actSequence["timestamp"].push(lastInteraction["timestamp"]);
                }
                else {
                    this.actSequence["timestamp"].push(null);
                }
                if (Object.keys(lastInteraction).includes("duration")) {
                    this.actSequence["duration"].push(lastInteraction["duration"]);
                }
                else {
                    this.actSequence["duration"].push(0);
                }
                this.actSequence["weight"].push(1);
            }
            else {
                var countLastSeen = this.actSequence["act"].filter(function (actID) {
                    return actID == lastInteraction["activityId"];
                }).length;
                if (countLastSeen == nbLastSeen) {
                    var firstIndex = this.actSequence["act"].indexOf(lastInteraction["activityId"]);
                    for (let key of Object.keys(this.actSequence)) {
                        this.actSequence[key].splice(firstIndex, 1);
                    }
                }
                this.actSequence["seq"].push(act);
                this.actSequence["ex"].push(lastInteraction["exerciseId"]);
                this.actSequence["act"].push(lastInteraction["activityId"]);
                this.actSequence["res"].push(lastInteraction["score"] < 0.7 ? 0 : 1);
                this.sequence.push({
                    exerciseId: lastInteraction["exerciseId"],
                    activityId: lastInteraction["activityId"],
                    objectiveId: lastInteraction["objectiveId"],
                    score: lastInteraction["score"],
                });
                if (Object.keys(lastInteraction).includes("timestamp")) {
                    this.actSequence["timestamp"].push(lastInteraction["timestamp"]);
                }
                else {
                    this.actSequence["timestamp"].push(null);
                }
                if (Object.keys(lastInteraction).includes("duration")) {
                    this.actSequence["duration"].push(lastInteraction["duration"]);
                }
                else {
                    this.actSequence["duration"].push(0);
                }
                this.actSequence["weight"].push(weight);
            }
        }
        catch (_a) { }
    }
    /**
     * updates the activity sequence with an history of student answers
     * @param pastHistory : history of student answers to questions
     * @param weight : weight given to interactions coming from the BM history (if there are some)
     * @param nbLastSeen : maximal number of interactions in each activity taken from the BM history
     */
    update_history(pastHistory, weight = 0.2, nbLastSeen = 4) {
        for (let nn = 0; nn < pastHistory.length; nn++) {
            this.base_update(pastHistory[nn], weight, nbLastSeen);
        }
    }
    /**
     * détermine le niveau de l'élève sur chaque exercice avec mean low et high estimate
     * @returns un dictionnaire de diagnostic de l'élève après le test
     */
    get_student_diagnosis() {
        const diagnosisDict = {};
        diagnosisDict["theta"] = Array.from(this.thetaEstimation);
        diagnosisDict["probabilities"] = {
            mean_estimate: {},
            low_estimate: {},
            high_estimate: {},
            pondered_estimate: {},
        };
        for (let obj in this.lvl_per_obj) {
            this.lvl_per_obj[obj] = this.lvl_per_obj[obj].map((mastery) => mastery > 0 ? 1 : 0);
        }
        diagnosisDict["predictedCompetences"] = this.lvl_per_obj;
        //const idExs = Array.from(Object.values(this.exercises_ontology)).flat();
        const discValues = Array.from(Object.values(this.discriminations_no_anc));
        const diffValues = Array.from(Object.values(this.difficulties));
        const probas = Array.from((0, irt_1.iccGenma)(this.thetaEstimation, discValues, diffValues).dataSync());
        const standardErrors = (0, irt_1.see)(this.InformationMatrix).map((item) => 0.5 * item);
        const lowProbas = Array.from((0, irt_1.iccGenma)(tf.sub(this.thetaEstimation, standardErrors).dataSync(), discValues, diffValues).dataSync());
        const highProbas = Array.from((0, irt_1.iccGenma)(tf.add(this.thetaEstimation, standardErrors).dataSync(), discValues, diffValues).dataSync());
        let meanRes = 0.0;
        for (let res of this.actSequence["res"]) {
            meanRes += res;
        }
        meanRes = (1.0 * meanRes) / this.actSequence["res"].length;
        let activitiesList = Object.values(this.ontology.activitiesOfObj).reduce((accumulator, value) => accumulator.concat(value), []);
        for (let activityIdx = 0; activityIdx < activitiesList.length; activityIdx++) {
            diagnosisDict["probabilities"]["mean_estimate"][activitiesList[activityIdx]] = probas[activityIdx];
            diagnosisDict["probabilities"]["low_estimate"][activitiesList[activityIdx]] = lowProbas[activityIdx];
            diagnosisDict["probabilities"]["high_estimate"][activitiesList[activityIdx]] = highProbas[activityIdx];
            diagnosisDict["probabilities"]["pondered_estimate"][activitiesList[activityIdx]] =
                Number(lowProbas[activityIdx]) +
                    meanRes *
                        (Number(highProbas[activityIdx]) - Number(lowProbas[activityIdx]));
        }
        diagnosisDict["probabilities"]["per_objective"] =
            this.compute_prob_data_per_obj(activitiesList, lowProbas, highProbas);
        diagnosisDict["sequence"] = this.sequence;
        if ("ifFailed_FailObj" in
            this.params["graph"]["graph"][this.ontology.objectives[0]])
            diagnosisDict["testStatus"] = this.check_test_recommendation_status();
        else {
            diagnosisDict["testStatus"] = null;
        }
        diagnosisDict["moduleCode"] =
            this.params["graph"]["graph"]["map_id_code"][this.main_act];
        return diagnosisDict;
    }
    /**
     * Compute estimation mastery per objective
     * @param activitiesList :
     * @param lp :
     * @param hp :
     * @returns mastery estimation over objectives
     */
    compute_prob_data_per_obj(activitiesList, lp, hp) {
        let res_prob_per_Obj = {};
        for (let i = 0; i < activitiesList.length; i++) {
            let activityId = activitiesList[i];
            let objID = this.ontology.get_objectiveID_of_activity(activityId);
            if (!(objID in res_prob_per_Obj)) {
                res_prob_per_Obj[objID] = {
                    res: [],
                    lowProbas: [],
                    highProbas: [],
                    hmlProbas: [],
                };
            }
            res_prob_per_Obj[objID]["lowProbas"].push(lp[i]);
            res_prob_per_Obj[objID]["highProbas"].push(hp[i]);
            res_prob_per_Obj[objID]["hmlProbas"].push(hp[i] - lp[i]);
            for (let ii = 0; ii < this.actSequence["ex"].length; ii++) {
                if (this.actSequence["act"][ii] == activityId) {
                    res_prob_per_Obj[objID]["res"].push(this.actSequence["res"][ii]);
                    break;
                }
            }
        }
        let computedProbs = {};
        for (let objID in res_prob_per_Obj) {
            let rpObj = res_prob_per_Obj[objID];
            computedProbs[objID] = {};
            computedProbs[objID]["pondered"] =
                (0, utils_1.mean)(rpObj["lowProbas"]) +
                    (0, utils_1.mean)(rpObj["res"]) * (0, utils_1.mean)(rpObj["hmlProbas"]);
            computedProbs[objID]["low_estimate"] = Math.max(computedProbs[objID]["pondered"] - (0, utils_1.mean)(rpObj["hmlProbas"]) / 2, 0);
            computedProbs[objID]["high_estimate"] = Math.min(computedProbs[objID]["pondered"] + (0, utils_1.mean)(rpObj["hmlProbas"]) / 2, 1);
        }
        return computedProbs;
    }
    check_test_recommendation_status() {
        let failedObj = [];
        let masterObj = [];
        //We iterate over each objective of the module
        for (let index = 0; index < this.ontology.objectives.length; index++) {
            let objId = this.ontology.objectives[index];
            this.ontology.get_objective_position;
            //A list of activities that shows the student fails the objective.
            let failed_states_to_check = this.params["graph"]["graph"][objId]["ifFailed_FailObj"];
            // The objective is failed if all activities marked "failed_states_to_check" are failed. If no activities marked the objective is notRelevant
            const isObjectiveFailed = this.test_objective_state(failed_states_to_check, this.lvl_per_obj[objId], 0);
            failedObj.push(isObjectiveFailed);
            //A list of activities that shows the student masters the objective.
            let master_states_to_check = this.params["graph"]["graph"][objId]["toMasterObj"];
            // The objective is mastered if all activities marked "master_states_to_check" are mastered If no activities marked the objective is notRelevant
            const isObjectiveMastered = this.test_objective_state(master_states_to_check, this.lvl_per_obj[objId], 1);
            masterObj.push(isObjectiveMastered);
        }
        //This cannot happen anymore I think
        if (failedObj.includes(null) && masterObj.includes(null)) {
            console.log("ATM Error: failedObj and masterObj are null");
            return null;
        }
        else if (failedObj.includes("check") && !failedObj.includes("notCheck")) {
            return "failed";
        }
        else if (masterObj.includes("check") && !masterObj.includes("notCheck")) {
            return "mastered";
        }
        else {
            return "intermediate";
        }
    }
    test_objective_state(states_to_check, states_value, value_to_compare) {
        //TODO WTF
        if (states_to_check.length != states_value.length) {
            console.log("ATM Error: states_to_check and states_value have different lengths", states_to_check, states_value);
            states_to_check = states_to_check[0];
        }
        //We get the indices of the activities that are marked as "toMasterObj" or "ifFailed_FailObj"
        let indicesMap = [];
        states_to_check.forEach((value, index) => {
            if (value == 1) {
                indicesMap.push(index);
            }
        });
        //If there are no activities to check, we return false
        if (indicesMap.length == 0) {
            return "notRelevant";
        }
        let check = true;
        // If any activity doesn't have the expected value (0 for fail and 1 for master), we return false
        indicesMap.forEach((value, index) => {
            if (states_value[index] != value_to_compare) {
                check = false;
            }
        });
        return check ? "check" : "notCheck";
    }
}
exports.default = ATM;
